import React, { useState } from "react";
import { Col, Form, Button, ListGroup } from "react-bootstrap";
import { FaWhatsapp, FaPhoneAlt, FaClipboardList, FaLightbulb, FaFileAlt, FaBell } from "react-icons/fa"; // Ícones para eventos
import { BsClock } from "react-icons/bs"; // Ícone de tempo

const eventIcons = {
    whats: <FaWhatsapp className="text-success" />,
    callAnalitics: <FaPhoneAlt className="text-primary" />,
    callTranscribe: <FaClipboardList className="text-warning" />,
    offerInsights: <FaLightbulb className="text-info" />,
    report: <FaClipboardList className="text-secondary" />,
    contracts: <FaFileAlt className="text-dark" />,
    alerts: <FaBell className="text-danger" />,
};

const Sidebar = ({ recentChats, onNewChat }) => {
    const [search, setSearch] = useState("");
    const [expanded, setExpanded] = useState(false);

    // Filtrar conversas pelo campo de busca
    const filteredChats = recentChats?.filter(chat =>
        chat.title.toLowerCase().includes(search.toLowerCase()) ||
        chat.description.toLowerCase().includes(search.toLowerCase())
    );

    // Definir a quantidade de itens visíveis
    const chatsToShow = expanded ? filteredChats : filteredChats.slice(0, 3);

    return (
        <Col
            md={12}
            className="me-4 d-flex flex-column"
            style={{
                padding: 20,
                height: "80vh",
                marginLeft: "auto",
                overflowY: "auto",
            }}
        >
            {/* Campo de busca */}
            <Form.Control
                type="text"
                placeholder="Buscar conversas anteriores..."
                className="mb-3"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            {/* Timeline de Conversas */}
            <ListGroup variant="flush" className="flex-grow-1">
                {chatsToShow.map((chat, index) => (
                    <ListGroup.Item key={index} className="d-flex align-items-start" style={{ border: "none", position: "relative" }}>
                        {/* Ícone Representativo */}
                        <div style={{ marginRight: 10, position: "relative" }}>
                            <div>{eventIcons[chat.type] || <FaClipboardList className="text-muted" />}</div>
                            {/* Linha vertical conectando os eventos */}
                            {index !== chatsToShow.length - 1 && (
                                <div style={{
                                    position: "absolute",
                                    left: "50%",
                                    top: "25px",
                                    height: "100%",
                                    width: "2px",
                                    backgroundColor: "#d0d5db",
                                    transform: "translateX(-50%)"
                                }} />
                            )}
                        </div>

                        {/* Conteúdo do Chat */}
                        <div>
                            <strong>{chat.title}</strong>
                            <div className="text-muted" style={{ fontSize: "14px" }}>{chat.description}</div>
                            {chat.lastModify && (
                                <div className="text-muted d-flex align-items-center" style={{ fontSize: "12px", marginTop: "5px" }}>
                                    <BsClock className="me-1" /> {chat.lastModify}
                                </div>
                            )}
                        </div>


                    </ListGroup.Item>
                ))}

                <ListGroup.Item  className="d-flex align-items-start" style={{ border: "none", position: "relative" }}>
                    {filteredChats.length > 3 && (
                        <Button
                            variant="link"
                            className="mt-2 text-primary d-flex align-items-center"
                            onClick={() => setExpanded(!expanded)}
                        >
                            {expanded ? "Exibir menos" : "Exibir mais"}
                        </Button>
                    )}
                </ListGroup.Item>
            </ListGroup>



            {/* Botão "Novo Chat" sempre visível */}
            {/*<Button*/}
            {/*    variant="primary"*/}
            {/*    className="w-100 mt-3"*/}
            {/*    onClick={onNewChat}*/}
            {/*>*/}
            {/*    Novo Chat*/}
            {/*</Button>*/}
        </Col>
    );
};

export default Sidebar;
